import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000, // 1 min
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 1,
    }
  }
});
